import DelayOverlay from '@ui/molecules/DelayOverlay.vue';
import RandomOverlay from '@ui/molecules/RandomOverlay.vue';
import OnEventOverlay from '@ui/molecules/OnEventOverlay.vue';
import GridTransformOverlay from '@ui/molecules/GridTransformOverlay.vue';
import SpawnerOverlay from '@ui/molecules/SpawnerOverlay.vue';

function getChildComponent(component) {
  if (!component) {
    return null;
  } else if (component.type === "delayTransform") {
    return DelayOverlay;
  } else if (component.type === "randomTransform") {
    return RandomOverlay;
  } else if (component.type === "onEventTransform") {
    return OnEventOverlay;
  } else if (component.type === "gridTransform") {
    return GridTransformOverlay;
  } else if (component.type === "spawner") {
    return SpawnerOverlay;
  } else {
    return null;
  }
}
export default getChildComponent;
